import React from 'react'
import businessData from 'sprockets_react/data/business/data'
import IndustrySelector from 'sprockets_react/components/business/IndustrySelector'
import LoadingIndicator from 'products/exclusive_lead/components/LoadingIndicator'
import LocationEditor from 'sprockets_react/components/business/LocationEditor'
import MembershipFooter from 'sprockets_react/components/business/memberships/MembershipFooter'
import PricingFooter from 'sprockets_react/components/business/memberships/PricingFooter'
import SelectInput from 'common/components/SelectInput'

const thresholdOptions = [
  {id: 0.33, value: '33%'},
  {id: 0.67, value: '67%'},
  {id: 1.00, value: '100%'}
]

class MembershipEdit extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      yearlyLeadsCount: 0,
      newMembershipBillingAmount: 0,
      newbillingAmount: 0,
      contractPrice: 0,
      currentBillingAmount: 0,
      billingDate: null,
      priceDifference: 0,
      additionalPayment: 0,
      additionalPaymentContract: 0,
      remainingDays: 0,
      currentAvgLeads: null,
      newAvgLeads: null,
      recurrence: null,
      radius: props.radius,
      suburb: props.suburb,
      disabled: false,
      hasActiveContract: props.hasActiveContract,
      hasActiveSignedContract: props.hasActiveSignedContract,
      relatedContractId: props.relatedContractId,
      arrears: props.arrears,
      halt: false,
      admin: props.admin,
      currentThreshold: props.currentThreshold
    }

    this.checkPricing = this.checkPricing.bind(this)
    this.handleComponentUpdate = this.handleComponentUpdate.bind(this)
    this.handleLeadSuppressantChange = this.handleLeadSuppressantChange.bind(this)
    this.handleRadiusChange = this.handleRadiusChange.bind(this)
    this.handleLocationChange = this.handleLocationChange.bind(this)
  }

  componentDidMount() {
    if (this.props.jobFilterLocked) {
      document.querySelectorAll("#edit-form input, #edit-form select, #edit-form button").forEach(el => el.disabled = true)
    }

    SS.locationAutocomplete('.js-suburb-field', this.handleLocationChange)

    let $membershipsContainer = $('#memberships');
    let $ccContainer = $membershipsContainer.find('.credit-card');
    let $ccSubmit = $ccContainer.find('#cc-submit');
    let $banner = $('#payment-banner')

    $banner.find('span.industry-close').on('click', function() {
      $banner.addHidden()
    })

    $ccSubmit.on('click', (event) => {
      event.preventDefault()

      let serialized_job_filter_data = businessData.serialized_job_filter_data
      let serialized_prices = '&'.concat($('#edit-membership-form').serialize())
      let data = serialized_job_filter_data.concat(serialized_prices)
      let $button = $(this)
      let url = '/products/membership'

      $button.addClass('disabled')
      $button.val('Processing payment request')
      this.setState({ disabled: true });

      $('.loading-overlay').rmHidden()
      $('#save-banner').addClass('slide-hide')

      $.ajax({
        url: url,
        type: 'POST',
        data: data
      }).done((data) => {
        if (data.error) {
          $banner.rmHidden()
          $banner.find('#flash-notice').text(data.error)
          $button.removeClass('disabled')
          $button.val('Confirm Card Details & Purchase')
          $('.loading-overlay').addHidden()
          this.setState({ disabled: false })
        }
        else {
          window.location.href = "/products/membership/edit" + "?show_banner=true"
        }
      }).fail(function(jqXHR, textStatus) {
          document.location.href = '/500'
      })
    })
  }

  handleComponentUpdate() {
    let saveBanner = document.getElementById('save-banner')
    let footer = document.getElementById('pricing-footer')
    let ccForm = document.getElementsByClassName('credit-card')[0]

    saveBanner.classList.remove('slide-hide')
    saveBanner.classList.add('active')
    footer.classList.add('hidden')
    ccForm.classList.add('hidden')
  }

  handleLeadSuppressantChange(event) {
    this.setState({ currentThreshold: event.currentTarget.value })
  }

  handleRadiusChange(event) {
    this.setState({ radius: event.currentTarget.value })
  }

  handleLocationChange(event, response) {
    this.setState({ suburb: response.item })
  }

  formattedDate(dateString) {
    let date = new Date(dateString)
    return date.toLocaleDateString('en-us', {month: 'long', day: 'numeric'})
  }

  addMonth(dateString, month) {
    let date = new Date(dateString)
    let d = date.getDate()
    date.setMonth(date.getMonth() + month)

    if (date.getDate() != d) {
      date.setDate(0);
    }

    date.setDate(date.getDate() - 1)

    return this.formattedDate(date)
  }

  checkPricing() {
    $('.loading-overlay').rmHidden()
    $('#save-banner').addClass('slide-hide')

    let serializedJobFilterData = $('#edit-form').serialize()

    businessData.serialized_job_filter_data = serializedJobFilterData

    $.ajax({
      url: '/products/membership/new_pricing',
      type: 'POST',
      dataType: 'json',
      data: serializedJobFilterData
    }).done((result) => {
      this.setState({
        yearlyLeadsCount: result.yearly_leads_count,
        additionalPayment: result.additional_payment,
        additionalPaymentContract: result.additional_payment_contract,
        additionalPaymentContractUpgrade: result.additional_payment_contract_upgrade,
        priceDifference: result.price_difference,
        billingDate: result.billing_date,
        currentBillingAmount: result.current_price,
        newMembershipBillingAmount: result.membership_new_price,
        newBillingAmount: result.new_price,
        contractPrice: result.contract_price,
        remainingDays: result.remaining_days,
        currentAvgLeads: result.current_avg_leads,
        newAvgLeads: result.new_avg_leads,
        recurrence: result.recurrence,
        arrears: result.arrears,
        halt: result.halt
      }, () => {
        let $footer = $('#pricing-footer')
        $footer.rmHidden()
        $('html, body').stop().animate({ scrollTop: $footer.offset().top }, 1000)
        $('#credit-price').text("$" + this.state.additionalPayment)
        $('.js-membership-custom-price').val(this.state.newBillingAmount)
        $('.js-membership-new-price').val(this.state.newMembershipBillingAmount)
        $('.js-membership-pay-now-price').val(this.state.additionalPayment)
        $('#save-banner').addClass('slide-hide')
        $('.loading-overlay').addHidden();
      })

    }).fail(function() {
      document.location.href = '/500'
    })
  }

  render() {
    return (
      <div>
        <div className='loading-overlay hidden'>
          <div className='overlay-content'>
            <LoadingIndicator isLoading />
          </div>
        </div>
        <div className="save-sticky slide-hide" id="save-banner">
          <div className="container">
            <div className="row">
              <div className="col-md-6 col-sm-7 hidden-xs">
                <h4>When you're finished editing your settings, see if the new settings change your Membership price</h4>
              </div>
              <div className="col-sm-4">
                <button className='btn btn-opaque btn-lg' onClick={this.checkPricing}>Check Changes</button>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <form role="form" action="/products/memberships" method="post" id="edit-form" className="form-horizontal" acceptCharset="UTF-8">
            <input type="hidden" name="_method" value="put" />
            <input type="hidden" value={this.props.auth_token} />
            <fieldset>
              <div className='col-xs-12'>
                <div className="card card-flat">
                  <div className="card-content card-pad-md">
                    <div className="font-21 bold">You are looking for work within
                    </div>
                    <div className="row">
                      <div className="col-xs-12 col-sm-4">
                        <input type='text'
                          autoFocus
                          className='p8 mt16 mr8 mb16 form-control sm-mb0'
                          name='radius'
                          value={this.state.radius}
                          onChange={this.handleRadiusChange}
                          disabled= { this.state.disabled ? "disabled" : ""}
                          id='radius'
                          size='40'
                        />
                      </div>
                      <div className="col-xs-12 col-sm-2 sm-p0 sm-mt32" style={{width: '120px'}}>
                        <span className="font-14 bold">kilometers of</span>
                      </div>
                      <div className="col-xs-12 col-sm-4 sm-pl0 mb20">
                        <input type='text'
                          id='location'
                          className='p8 js-suburb-field mt16 form-control ml0'
                          name='location'
                          defaultValue={this.state.suburb.name}
                          onChange={this.handleLocationChange}
                          disabled= { this.state.disabled ? "disabled" : ""}
                          size='40'
                        />
                        <input type='hidden'
                          name='suburb_id'
                          value={this.state.suburb.id}
                        />
                      </div>
                      <div className='col-xs-12'>
                        <LocationEditor
                          radius={this.state.radius}
                          suburb={this.state.suburb}
                          handleComponentUpdate={this.handleComponentUpdate}
                          mapOnly
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='col-xs-12'>
                <IndustrySelector
                  industry={this.props.industry}
                  disabled= { this.state.disabled ? "disabled" : ""}
                  action="update"
                  handleComponentUpdate={this.handleComponentUpdate}
                  jobFilterLocked={this.props.jobFilterLocked}
                />
              </div>
              {
                (this.state.hasActiveSignedContract && !this.state.arrears && !this.state.halt && this.state.admin) &&
                  <div className='col-xs-12 mt24'>
                    <div className='card card-flat'>
                      <div className='card-content card-pad-md'>
                        <SelectInput
                          label='Lead Suppressant'
                          name='custom_threshold'
                          options={thresholdOptions}
                          onChangeHandler={this.handleLeadSuppressantChange}
                          defaultValue={this.state.currentThreshold}
                        />
                      </div>
                    </div>
                  </div>
              }
            </fieldset>
          </form>
        </div>
        <MembershipFooter
          paymentAmount={this.props.payment_amount}
          previousBillingDate={this.props.previous_billing_date}
          initialBillingDate={this.formattedDate(this.props.next_billing_date)}
          finalBillingDate={this.addMonth(this.props.next_billing_date, 1)}
          membershipCycleEndDate={this.props.membership_cycle_end_date}
          membershipType={this.props.membership_type}
          membershipEndDate={this.props.membership_end_date}
          hasNextBilling={this.props.has_next_billing}
          hasActiveContract={this.state.hasActiveContract}
          hasActiveSignedContract={this.state.hasActiveSignedContract}
          relatedContractId={this.state.relatedContractId}
          exclusiveLeadDetails={this.props.exclusiveLeadDetails}
          exclusiveLeadOnlyContract={this.props.exclusiveLeadOnlyContract}
          supportPhoneNumber={this.props.supportPhoneNumber}
          totalExclusiveLeadCredits={this.props.totalExclusiveLeadCredits}
        />
        <PricingFooter
          yearlyLeadsCount={this.state.yearlyLeadsCount}
          priceDifference={this.state.priceDifference}
          additionalPayment={this.state.additionalPayment}
          additionalPaymentContract={this.state.additionalPaymentContract}
          additionalPaymentContractUpgrade={this.state.additionalPaymentContractUpgrade}
          remainingDays={this.state.remainingDays}
          billingDate={this.state.billingDate}
          currentBillingAmount={this.state.currentBillingAmount}
          newMembershipBillingAmount={this.state.newMembershipBillingAmount}
          newBillingAmount={this.state.newBillingAmount}
          contractPrice={this.state.contractPrice}
          membershipType={this.props.membershipType}
          hasNextBilling={this.props.has_next_billing}
          currentAvgLeads={this.state.currentAvgLeads}
          newAvgLeads={this.state.newAvgLeads}
          recurrence={this.state.recurrence}
          industry={this.props.industry}
          radius={this.state.radius}
          suburbId={this.state.suburb.id}
          billingDateValid={this.props.billingDateValid}
          hasSignedContract={this.props.hasSignedContract}
          hasActiveSignedContract={this.state.hasActiveSignedContract}
          hasActiveContract={this.state.hasActiveContract}
          relatedContractId={this.state.relatedContractId}
          arrears={this.state.arrears}
          halt={this.state.halt}
          admin={this.state.admin}
          exclusiveLeadDetails={this.props.exclusiveLeadDetails}
          exclusiveLeadOnlyContract={this.props.exclusiveLeadOnlyContract}
        />
      </div>
    )
  }
}

export default MembershipEdit
